<template>
<div id="index">

  <div class="common-seach-wrap">
    <el-form size="small" :inline="true" :model="searchObj">
      <!-- 业务类型由下方 Tab 切换 -->
      <!-- 对单编号 -->
      <el-form-item label="对单编号">
        <el-input
          v-model="searchObj.order_no"
          placeholder="请输入对单编号"
          clearable
        />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchObj.status" placeholder="请选择状态">
          <el-option value="" label="全部"></el-option>
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市">
        <el-select v-model="searchObj.city_id" placeholder="请选择城市">
          <el-option value="" label="全部"></el-option>
          <el-option
            v-for="item in cityList"
            :key="item.city_id"
            :label="item.name"
            :value="item.city_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="删除状态">
        <el-select v-model="searchObj.delete_filter" placeholder="请选择">
          <el-option label="正常" value="0"></el-option>
          <el-option label="已删除" value="1"></el-option>
          <el-option label="全部" value="all"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="pageChange(1)"
        >查询</el-button>
      </el-form-item>
    </el-form>
  </div>

  <div class="product-content">
    <div class="table-wrap">
      <el-tabs v-model="activeBizTab" class="issueorder-biz-tabs" @tab-click="onBizTabClick">
        <el-tab-pane label="全部对单" name="all" />
        <el-tab-pane
          v-for="item in bizTypeList"
          :key="item.value"
          :label="item.label"
          :name="item.value"
        />
      </el-tabs>
      <el-table size="small" :data="list">
        <!-- 对单ID -->
        <el-table-column prop="id" label="对单ID" width="90"></el-table-column>
        <!-- 发单用户 -->
        <el-table-column label="发单用户" width="220">
          <template slot-scope="scope">
            <div class="userInfo">
              <img :src="scope.row.user && scope.row.user.avatarUrl" alt="">
              <div class="main">
                <p class="name">{{ scope.row.user && scope.row.user.nickName }}</p>
                <p class="text">ID:{{ scope.row.user && scope.row.user.user_id }}</p>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 接单用户信息 -->
        <el-table-column label="接单用户信息" width="140">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="openContactMerchants(scope.row)"
            >
              {{ Number(scope.row.contact_merchant_count || 0) }}
            </el-link>
          </template>
        </el-table-column>

        <!-- 对单编号 -->
        <el-table-column prop="order_no" label="对单编号" width="180"></el-table-column>

        <!-- 城市 -->
        <el-table-column prop="city.name" label="城市" width="100"></el-table-column>

        <!-- 对单金额（元） -->
        <el-table-column label="对单金额(元)" width="120">
          <template slot-scope="scope">
            {{ formatIssueOrderMoney(scope.row.money) }}
          </template>
        </el-table-column>

        <!-- 业务类型 -->
        <el-table-column label="业务类型" width="140">
          <template slot-scope="scope">
            {{ bizTypeText(scope.row.biz_type) }}
          </template>
        </el-table-column>

        <el-table-column label="业务备注" min-width="220">
          <template slot-scope="scope">
            <template v-if="scope.row.biz_type === 'exchange'">
              <div>{{ scope.row.biz_remark || '-' }}</div>
              <div v-if="scope.row.exchange_goods_hint" class="biz-remark-sub">{{ scope.row.exchange_goods_hint }}</div>
            </template>
            <template v-else-if="scope.row.biz_type === 'fund'">
              <span v-if="Number(scope.row.fund_is_anonymous) === 1">匿名发布</span>
              <span v-else>{{ fundContactDisplay(scope.row) }}</span>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <!-- 文件信息（最多展示3个：图片缩略图或附件名） -->
        <el-table-column label="文件信息" width="260">
          <template slot-scope="scope">
            <div v-for="(item, index) in (scope.row.files || []).slice(0,3)" :key="index" style="margin-bottom: 4px;">
              <template v-if="isImage(item.file_path)">
                <el-image
                  :src="item.file_path"
                  fit="cover"
                  :preview-src-list="(scope.row.files || []).map(i => i.file_path)"
                  style="width: 50px;height: 50px;margin-right: 4px;"
                />
              </template>
              <template v-else>
                <span class="doc-file-wrap">
                  <span class="doc-name">{{ item.file_name || item.real_name || '附件' }}</span>
                  <a
                    v-if="isPdf(item)"
                    :href="item.file_path"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="doc-btn"
                  >预览</a>
                  <a
                    :href="item.file_path"
                    :download="item.file_name || item.real_name || '附件'"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="doc-btn"
                  >下载</a>
                </span>
              </template>
            </div>
            <span v-if="(scope.row.files || []).length>3">更多...</span>
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="isDeletedRow(scope.row)" size="small" type="info">已删除</el-tag>
            <template v-else>
              <el-tag size="small" v-if="scope.row.status=='10'" type="success">待撮合</el-tag>
              <el-tag size="small" v-else-if="scope.row.status=='40'" type="primary">对单中</el-tag>
              <el-tag size="small" v-else-if="scope.row.status=='20'" type="warning">已完结</el-tag>
              <el-tag size="small" v-else type="danger">已关闭</el-tag>
            </template>
          </template>
        </el-table-column>

        <el-table-column label="热门" width="72">
          <template slot-scope="scope">
            <el-tag v-if="Number(scope.row.hot_recommend_time) > 0" size="mini" type="danger">热</el-tag>
            <span v-else class="readonly-text">—</span>
          </template>
        </el-table-column>

        <!-- 添加时间 -->
        <el-table-column prop="create_time" label="添加时间" width="180"></el-table-column>

        <!-- 操作 -->
        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <template v-if="isDeletedRow(scope.row)">
              <el-button @click="showDetail(scope.row)" type="text" size="small" v-auth="'/issueorder/issueorder/detail'">详情</el-button>
              <el-button @click="restoreItem(scope.row)" type="text" size="small" v-auth="'/issueorder/issueorder/restore'">恢复</el-button>
            </template>
            <template v-else>
              <el-button @click="showDetail(scope.row)" type="text" size="small" v-auth="'/issueorder/issueorder/detail'">详情</el-button>
              <!-- 已完结状态不可编辑：隐藏编辑按钮 -->
              <el-button
                v-if="scope.row.status != '20' && scope.row.biz_type !== 'cashout'"
                @click="showEdit(scope.row)"
                type="text"
                size="small"
                v-auth="'/issueorder/issueorder/edit'"
              >编辑</el-button>
              <el-button v-if="scope.row.status != '20' && scope.row.biz_type === 'cashout'" v-auth="'/issueorder/cashoutv2/edit'" type="text" size="small" @click="$router.push({ path: '/issueorder/cashoutv2/index', query: { id: scope.row.id } })">变现编辑</el-button>
              <el-button
                v-if="Number(scope.row.hot_recommend_time) <= 0"
                @click="setHotRecommend(scope.row, 'set')"
                type="text"
                size="small"
              >热门</el-button>
              <el-button
                v-else
                @click="setHotRecommend(scope.row, 'clear')"
                type="text"
                size="small"
              >取消热门</el-button>
              <el-button @click="openRecommend(scope.row)" type="text" size="small">今日大单</el-button>
              <el-button @click="deleteItem(scope.row)" type="text" size="small" v-auth="'/issueorder/issueorder/delete'">删除</el-button>
              <el-button v-if="scope.row.status != '10'" @click="changeStatus(scope.row, 10)" type="text" size="small" v-auth="'/issueorder/issueorder/status'">设为上架</el-button>
              <el-button v-if="scope.row.status != '20'" @click="changeStatus(scope.row, 20)" type="text" size="small" v-auth="'/issueorder/issueorder/status'">设为完结</el-button>
              <el-button v-if="scope.row.status != '30'" @click="changeStatus(scope.row, 30)" type="text" size="small" v-auth="'/issueorder/issueorder/status'">设为关闭</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

  <div class="pagination">
    <el-pagination
      @current-change="pageChange"
      background
      :current-page="searchObj.page"
      :page-size="searchObj.list_rows"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>

  <AddEdit ref="addEdit" @refresh="getData" :cityList="cityList"></AddEdit>

  <!-- 推荐到今日大单弹窗 -->
  <el-dialog title="推荐到今日大单" :visible.sync="recommendVisible" width="500px">
    <el-form label-width="100px" size="small">
      <el-form-item label="对单标题">
        <el-input v-model="recommendForm.title" placeholder="请输入推荐展示的标题" />
      </el-form-item>
      <el-form-item label="对单编号">
        <span class="readonly-text">{{ recommendForm.order_no }}</span>
      </el-form-item>
      <el-form-item label="对单ID">
        <span class="readonly-text">{{ recommendForm.issue_order_id }}</span>
      </el-form-item>
      <el-form-item label="业务类型">
        <span class="readonly-text">{{ recommendForm.biz_type_text }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="recommendVisible = false">取消</el-button>
      <el-button type="primary" :loading="recommendLoading" @click="submitRecommend">确定推荐</el-button>
    </div>
  </el-dialog>

  <!-- 接洽商家列表 -->
  <el-dialog
    title="接洽商家列表"
    :visible.sync="contactDialogVisible"
    width="760px"
  >
    <div style="margin-bottom: 10px; color: #606266;">
      对单编号：{{ contactDialogOrderNo }}，接洽商家数量：{{ contactDialogTotal }}
    </div>
    <el-table size="small" :data="contactDialogList" v-loading="contactDialogLoading">
      <el-table-column prop="user_id" label="用户ID" width="100" />
      <el-table-column prop="user_mobile" label="用户号码" width="140" />
      <el-table-column prop="shop_supplier_id" label="商家ID" width="100" />
      <el-table-column prop="supplier_name" label="商家名称" min-width="180" />
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="contactDialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>
import IssueOrderApi from '@/api/issueorder'
import NeedApi from '@/api/need' // 复用城市接口 /shop/city.city/getAll
import AddEdit from './addEdit.vue'
import { formatIssueOrderMoney } from '@/utils/issueOrderFormat'
import {
  MAIN_KEY,
  fetchLabelValueOptions,
  FALLBACK_ISSUE_ORDER_STATUS_LIST,
  FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST,
  bizTypeTextFromOptions,
} from '@/utils/sysEnumOptions'

export default {
  components: { AddEdit },
  data() {
    const bizTypeValues = ['project', 'exchange', 'fund', 'cashout', 'acquisition', 'rent', 'loan']
    const qBiz = (this.$route.query.biz_type || '').trim()
    const bizFromRoute = bizTypeValues.indexOf(qBiz) !== -1 ? qBiz : ''
    return {
      /** 与 searchObj.biz_type 同步：all | project | exchange | … */
      activeBizTab: bizFromRoute || 'all',
      searchObj: {
        page: 1,
        list_rows: 10,
        city_id: '',
        status: '',
        biz_type: bizFromRoute,
        order_no: '',
        /** 软删筛选：0 正常 | 1 已删除 | all 全部 */
        delete_filter: '0',
      },
      list: [],
      total: 0,
      cityList: [],
      statusList: [...FALLBACK_ISSUE_ORDER_STATUS_LIST],
      bizTypeList: [...FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST],
      recommendVisible: false,
      recommendLoading: false,
      contactDialogVisible: false,
      contactDialogLoading: false,
      contactDialogOrderNo: '',
      contactDialogTotal: 0,
      contactDialogList: [],
      recommendForm: {
        issue_order_id: 0,
        title: '',
        order_no: '',
        biz_type_text: ''
      }
    }
  },
  created() {
    Promise.all([
      fetchLabelValueOptions(MAIN_KEY.issueOrderListStatus, { stringValue: true }, FALLBACK_ISSUE_ORDER_STATUS_LIST),
      fetchLabelValueOptions(MAIN_KEY.issueOrderBizType, { stringValue: true }, FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST),
    ]).then(([st, bt]) => {
      this.statusList = st
      this.bizTypeList = bt
    }).catch(() => {})
    this.getData()
    this.getCityList()
  },
  watch: {
    '$route.query.biz_type'(val) {
      const v = (val || '').trim()
      const ok = ['project', 'exchange', 'fund', 'cashout', 'acquisition', 'rent', 'loan'].indexOf(v) !== -1
      this.activeBizTab = ok ? v : 'all'
      this.searchObj.biz_type = ok ? v : ''
      this.pageChange(1)
    }
  },
  methods: {
    formatIssueOrderMoney,
    onBizTabClick(tab) {
      const name = tab.name || tab.paneName
      this.activeBizTab = name
      this.searchObj.biz_type = name === 'all' ? '' : name
      this.pageChange(1)
    },
    isDeletedRow(row) {
      return Number(row && row.is_delete) === 1
    },
    // 业务类型文本（与 bizTypeList / 枚举表同步）
    bizTypeText(bizType) {
      return bizTypeTextFromOptions(bizType, this.bizTypeList)
    },

    /** 我有资金列表：联系人摘要（数据来自列表接口批量附带字段） */
    fundContactDisplay(row) {
      const name = (row && row.fund_contact_name) || ''
      const phone = (row && row.fund_contact_phone) || ''
      if (!name && !phone) return '-'
      return [name, phone].filter(Boolean).join(' / ')
    },

    getData() {
      IssueOrderApi.index(this.searchObj).then(result => {
        const list = result.data.list
        this.list = list.data
        this.total = list.total
      })
    },

    // 判断是否是图片类型
    isImage(path) {
      if (!path) return false
      const lower = String(path).toLowerCase()
      return /\.(jpe?g|png|gif|webp)$/.test(lower)
    },
    // 判断是否为 PDF（用于显示预览按钮）
    isPdf(item) {
      if (!item) return false
      const p = (item.file_path || item.file_name || item.real_name || '').toLowerCase()
      return p.indexOf('.pdf') !== -1
    },

    // 获取城市列表（沿用 need 模块接口）
    getCityList() {
      NeedApi.cityAll().then(result => {
        const list = result.data.list
        this.cityList = list
      })
    },

    // 恢复软删对单
    restoreItem(row) {
      this.$confirm('确定将该对单恢复为正常状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        IssueOrderApi.restore({ issue_order_id: row.id }).then(() => {
          this.$message({
            message: '恢复成功',
            type: 'success'
          })
          this.getData()
        })
      }).catch(() => {})
    },

    // 删除
    deleteItem(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        IssueOrderApi.delete({ issue_order_id: row.id }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        })
      })
    },

    setHotRecommend(row, action) {
      const tip = action === 'set' ? '设为热门推荐' : '取消热门推荐'
      this.$confirm('确定' + tip + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        IssueOrderApi.hotRecommend({ issue_order_id: row.id, action }).then(() => {
          this.$message.success('操作成功')
          this.getData()
        })
      }).catch(() => {})
    },

    // 切换状态：10=待撮合 20=完结 30=关闭
    changeStatus(row, targetStatus) {
      const statusText = { 10: '待撮合', 20: '完结', 30: '关闭' }[targetStatus]
      this.$confirm('确定设为「' + statusText + '」吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        IssueOrderApi.status({ issue_order_id: row.id, status: targetStatus }).then(() => {
          this.$message.success('已设为' + statusText)
          this.getData()
        })
      }).catch(() => {})
    },

    // 详情
    showDetail(row) {
      this.$refs.addEdit.show(row, 'detail')
    },

    // 编辑
    showEdit(row) {
      this.$refs.addEdit.show(row, 'edit')
    },

    // 分页
    pageChange(page) {
      this.searchObj.page = page
      this.getData()
    },

    // 打开推荐弹窗（对单数据自动带出，仅需填写推荐标题）
    openRecommend(row) {
      this.recommendForm = {
        issue_order_id: row.id,
        title: row.title || '',
        order_no: row.order_no || '',
        biz_type_text: this.bizTypeText(row.biz_type)
      }
      this.recommendVisible = true
    },

    submitRecommend() {
      this.recommendLoading = true
      IssueOrderApi.recommend({
        issue_order_id: this.recommendForm.issue_order_id,
        title: (this.recommendForm.title || '').trim()
      }).then(res => {
        this.recommendLoading = false
        if (res.code === 1) {
          this.$message.success(res.msg || '推荐成功')
          this.recommendVisible = false
        } else {
          this.$message.error(res.msg || '推荐失败')
        }
      }).catch(() => { this.recommendLoading = false })
    },
    // 打开接洽商家弹窗
    openContactMerchants(row) {
      if (!row || !row.id) return
      this.contactDialogVisible = true
      this.contactDialogLoading = true
      this.contactDialogOrderNo = row.order_no || ''
      this.contactDialogTotal = Number(row.contact_merchant_count || 0)
      this.contactDialogList = []
      IssueOrderApi.contactMerchants({ issue_order_id: row.id }, true).then(res => {
        this.contactDialogLoading = false
        this.contactDialogList = (res.data && res.data.list) ? res.data.list : []
        this.contactDialogTotal = (res.data && res.data.total != null)
          ? Number(res.data.total)
          : this.contactDialogList.length
      }).catch(() => {
        this.contactDialogLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.issueorder-biz-tabs {
  margin-bottom: 12px;
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}
.userInfo {
  display: flex;
  img {
    width: 40px;
    height: 40px;
  }
  .main {
    flex: 1;
    padding-left: 10px;
    .name {
      font-weight: bold;
    }
    .text {
      color: #999;
    }
  }
}
.el-image {
  width: 50px;
  height: 50px;
  margin-right: 4px;
}
.doc-file-wrap {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.doc-file-wrap .doc-name {
  margin-right: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.doc-file-wrap .doc-btn {
  font-size: 12px;
  color: #409EFF;
  text-decoration: none;
}
.doc-file-wrap .doc-btn:hover {
  text-decoration: underline;
}
.readonly-text {
  color: #606266;
  font-size: 13px;
}
.biz-remark-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.45;
  word-break: break-word;
}
</style>




// WEBPACK FOOTER //
// src/views/issueorder/issueorder/index.vue